import i18n from 'i18next'
// import XHR from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
// import { reactI18nextModule } from 'react-i18next'

import * as commonEn from './translations/en.json'
import * as commonPl from './translations/pl.json'
import * as customEn from './custom/translations/en.json'
import * as customPl from './custom/translations/pl.json'

i18n
  // .use(XHR)
  .use(LanguageDetector) // did not refresh language setting on <Redirect to="/lng" />, will other links work? 
  // .use(reactI18nextModule) // if not using I18nextProvider
  .init({
    detection: {
      // order and from where user language should be detected
      order: ['path'],
    
      // keys or params to lookup language from
      // lookupQuerystring: 'lng',
      // lookupCookie: 'lng',
      // lookupLocalStorage: 'i18nextLng',
      lookupFromPathIndex: 0,
      // lookupFromSubdomainIndex: 0,
    
      // cache user language on
      // caches: [ ],
      // caches: ['localStorage', 'cookie'],
      // excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
    
      // optional expire and domain for set cookie
      // cookieMinutes: 10,
      // cookieDomain: 'myDomain',
    
      // optional htmlTag with lang attribute, the default is:
      // htmlTag: document.documentElement
    },
    fallbackLng: 'pl', // for english chagne to 'en'
    // lng: 'en-GB',
    // lng: 'pl',
    // whitelist: ['en', 'pl'],
    // debug: true,


    ns: ['common', 'custom'],
    defaultNS: 'common',

    resources: {
      en: {
        common: commonEn,
        custom: customEn
      },
      pl: {
        common: commonPl,
        custom: customPl
      }
    },

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    // react i18next special options (optional)
    react: {
      wait: false,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    }
  })

export default i18n


// WEBPACK FOOTER //
// ./src/i18n.js